import config from 'config';

import { intl } from 'i18n';

import { 
  PredictedPlace,
  GeocodeResult,
  GeocodeProps
} from '../types';

interface LookupResponse {
  position: {
    lat: number;
    lng: number;
  };
  address: {
    label: string;
  };
  mapView?: {
    south: number;
    west: number;
    north: number;
    east: number;
  };
}

export const hereMapApi = {
  getPredictedPlaces: async (search: string): Promise<PredictedPlace[]> => {
    const autocompleteResponse = (await fetch(
      `https://autosuggest.search.hereapi.com/v1/autosuggest?q=${search}&apiKey=${config.hereAppKey}&in=bbox:-9.50,35.58,65.25,71.2&lang=${intl.locale || intl.defaultLocale}&limit=10`
    )) as any;
    const { items = [] } = await autocompleteResponse.json();

    return (
      items
        .filter((item: any) => item.address)
        .map(({ id, address }: any) => ({
          key: address.label,
          value: address.label,
          metadata: {
            placeId: id,
          },
        }))
    );
  },
  geocode: async ({ placeId, coordinates }: GeocodeProps): Promise<GeocodeResult> => {
    if (placeId) {
      const autocompleteResponse = await fetch(`https://lookup.search.hereapi.com/v1/lookup?id=${placeId}&apiKey=${config.hereAppKey}`) as any;
      const { position, address } = await autocompleteResponse.json() as LookupResponse;
      return {
        coordinates: {
          latitude: position.lat,
          longitude: position.lng
        },
        address: address.label
      };
    } else {
      const autocompleteResponse = await fetch(`https://revgeocode.search.hereapi.com/v1/revgeocode?at=${coordinates?.lat},${coordinates?.lng}&apiKey=${config.hereAppKey}&lang=${intl.locale || intl.defaultLocale}`) as any;
      const { items: [firstItem] } = await autocompleteResponse.json() as any;

      return {
        coordinates: {
          latitude: firstItem.position.lat,
          longitude: firstItem.position.lng
        },
        address: firstItem.title
      };
    }
  }
};

